import { cn } from "@postcheesy/core-utils";
import React from "react";

export interface ContainerProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div className={cn("container", className)} {...props} ref={ref}>
        {children}
      </div>
    );
  },
);
